// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
// eslint-disable-next-line no-shadow
export enum HelpObjectTypes {
    HelpObjectStoreRequestForm = 'HelpObjectStoreRequestForm',
    HelpObjectStoreArticle = 'HelpObjectStoreArticle',
    HelpObjectStoreChannel = 'HelpObjectStoreChannel',
    HelpObjectStoreQueryError = 'HelpObjectStoreQueryError',
}
